import React, { useCallback } from "react";

import { Input } from "DesignSystem/Input";
import { Modal } from "DesignSystem/Modal";
import "./LinkModal.scss";

const LinkModal = ({
  linkModalClass,
  showLinkModal,
  setShowLinkModal,
  getSelectedText,
  linkState,
  setLinkState,
  textToDisplay,
  setTextToDisplay,
  setLink,
  dir,
  urlPlaceholder = "Add url here",
  textPlaceholder = "Text to display",
  insertLink = "Insert Link",
  done = "Done",
}) => {
  const handleLinkIconClick = useCallback(() => {
    if (linkState && (textToDisplay || getSelectedText().trim() !== "")) {
      setLink(linkState, textToDisplay);
    }
  }, [linkState, textToDisplay]);

  return (
    <Modal
      visible={showLinkModal}
      title={insertLink}
      onCancel={() => setShowLinkModal(false)}
      width={"650px"}
      footer={null}
      destroyOnClose={true}
      centered={true}
      className={dir === "rtl" ? "link-modal-rtl" : ""}
    >
      <div className={`${linkModalClass} link-modal`} dir={dir}>
        <div
          className={`px-30 pt-30 b-r-regular link-modal-fields ${
            getSelectedText().trim() === ""
              ? "link-modal-fields-no-selection"
              : "link-modal-fields-has-selection"
          }`}
        >
          <div>
            <span>URL</span>
            <Input
              placeholder={urlPlaceholder}
              onChange={(e) => {
                setLinkState(e.target.value);
              }}
            />
          </div>

          {getSelectedText().trim() === "" && (
            <div className="pt-25">
              <span>{textPlaceholder}</span>
              <Input
                placeholder={textPlaceholder}
                onChange={(e) => {
                  setTextToDisplay(e.target.value);
                }}
              />
            </div>
          )}
        </div>

        <div className="color-white flex justify-end link-modal-submit-area">
          <div
            onClick={handleLinkIconClick}
            className={`${
              dir === "rtl" ? "ml-15" : "mr-15"
            } mt-10 fs-default cursor-pointer link-modal-submit-area-update ${
              linkState && (textToDisplay || getSelectedText().trim() !== "")
                ? "link-modal-submit-area-update-enable"
                : "link-modal-submit-area-update-disable"
            }`}
          >
            {done}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LinkModal;
